import React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import ReactDOM from 'react-dom/client';
import { HashRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import apTheme, { Fonts } from "./theme/APChakraTheme";
import { SettingsProvider } from "./contexts/SettingsContext";
import firebaseInstance from "./firebaseConfig";
import polyfill from "./polyfillScript";
import { NetworkProvider } from "./providers/NetworkProvider";
import { InitializationModal } from "./components/modals/InitializationModal";
import { VocabIntlProvider } from "./hooks/useVocabTranslation";

const initialInteractiveExercise = async () => {
  // We initialize polyfill and main.js from the shared library domain 
  firebaseInstance.initializeEnvironment();
  polyfill.initializePolyfill(process.env.REACT_APP_SHAREDLIB_DOMAIN);
  const rootElement = document.getElementById("root");
  if (rootElement) {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <HashRouter basename={`/`}>
          <NetworkProvider endpoint={process.env.REACT_APP_API_STATUS!} alwaysValidate={true}>
            <SettingsProvider>
              <ChakraProvider theme={apTheme}>
                <VocabIntlProvider locale={"fr"} logError={1}>
                  <Fonts />
                  <InitializationModal/>
                </VocabIntlProvider>
              </ChakraProvider>
            </SettingsProvider>
          </NetworkProvider>
        </HashRouter>
      </React.StrictMode>,);
  } else {
    console.error("Root element not found!");
  }
}

Object.assign(window, {
  ExerciseInteractive: {
    initialInteractiveExercise
  }
});

// Initialize the app immediately in web mode (non-Cordova)
// In Cordova mode, it will be called by deviceready event in index.html
if (!window.cordova) {
  initialInteractiveExercise();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
